'use strict';

import Alerts from 'lib/alerts';

import template from '../../templates/employee/RemovalModal.ejs';
import ModalFormView from 'commons/views/ModalForm.js';
import loader from 'helpers/loader.js';

import EmployeeRemoval from 'newModels/employee-removal.js';

module.exports = ModalFormView.extend({
    initialize: function(options) {
        this.model = new EmployeeRemoval();
        this.model.setEmployee(options.employee);

        this.options = Object.assign(options, {
            template:    template,
            actOnCancel: false
        });

        return ModalFormView.prototype.initialize.apply(this, [this.options]);
    },

    bindHandlers: function() {
        ModalFormView.prototype.bindHandlers.apply(this, arguments);

        this.model.on('change:reason', this.toggleIsReported, this);
    },

    unbindHandlers: function() {
        ModalFormView.prototype.unbindHandlers.apply(this, arguments);

        this.model.off('change:reason', this.toggleIsReported);
    },

    toggleIsReported: function(model) {
        this.$('.js-isReported').toggleClass(
            'hidden', (model.get('reason') !== 5)
        );
    },

    resetPayrollConfirm: function() {
        return new Promise((resolve, reject) => {
            if (!_.isObject(this.options.unsubmittedPayroll)) {
                return resolve(true);
            }

            Alerts.show('infoConfirm', {
                title: 'Your saved payroll will be modified!',
                text: 'You have an unsubmitted payroll saved. ' +
                    'If you continue, the payroll details of this employee ' +
                    'will be updated based on the modifications you are ' +
                    'about to save. Also, any unsaved payroll details will ' +
                    'be lost.',
                confirmButtonText: 'Yes, Archive Employee'
            }).then(() => resolve(), err => reject(err));
        });
    },

    save: function(ev) {
        if (!this.model.isValid()) {
            this.invalid(this.model, {errors: this.model.validationError});
            return;
        }

        const $el = this.$(ev.currentTarget);

        this.resetPayrollConfirm().then(() => {
            const stopLoader = loader.startFullScreen($el);
            return this.options.employee.dismiss(this.model.attributes)
                .then(() => {
                    if (this.options.unsubmittedPayroll) {
                        return this.options.unsubmittedPayroll.resetEmployee({
                            employee: this.model.getEmployee()
                        });
                    }
                })
                .then(() => {
                    this.hide();
                    this.trigger('destroy');
                })
                .catch(err => {
                    Alerts.show('criticalError', err);
                })
                .finally(stopLoader);
        });
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/employee/RemovalModal.js